import React, { useContext, useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { AuthContext } from '../App'; // Assuming App.js exports AuthContext
import { useNavigate } from 'react-router-dom';
import LoadingScreen from './LoadingScreen';

const LoginView = () => {
  const { handleLoginSuccess, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // If user is already authenticated, redirect to home
  React.useEffect(() => {
    if (user && user.is_admin && !isLoading) {
      navigate('/', { replace: true });
    }
  }, [user, navigate, isLoading]);

  const onLoginSuccess = (credentialResponse) => {
    if (handleLoginSuccess) {
      console.log("Starting login process...");
      setIsLoading(true);
      handleLoginSuccess(credentialResponse)
        .then(() => {
          console.log("Login successful, waiting for loading screen to complete...");
          // Loading screen will handle the delay and navigation
        })
        .catch(error => {
          console.error("Login process failed:", error);
          setIsLoading(false);
          alert('Login failed. Please try again.');
        });
    } else {
      console.error("handleLoginSuccess is not defined");
    }
  };

  const handleLoadingComplete = () => {
    console.log("Loading complete, navigating to home...");
    setIsLoading(false);
    navigate('/', { replace: true });
  };

  const onLoginFailure = (error) => {
    console.error('Google Login Failed:', error);
    // You can display an error message to the user here
    alert('Login failed. Please try again.');
  };

  return (
    <>
      <LoadingScreen 
        isVisible={isLoading} 
        onComplete={handleLoadingComplete} 
      />
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
        <div className="bg-white p-8 md:p-12 rounded-xl shadow-2xl text-center max-w-md w-full">
          <h1 className="text-3xl font-bold text-gray-800 mb-3">Admin Panel</h1>
          <p className="text-gray-600 mb-8">Please sign in with your Google account to continue.</p>
          <div className="flex justify-center">
             <GoogleLogin
              onSuccess={onLoginSuccess}
              onError={onLoginFailure}
              useOneTap
              shape="rectangular"
              theme="outline"
              size="large"
            />
          </div>
          <p className="mt-8 text-sm text-gray-500">
            Only authorized administrators can access this panel.
          </p>
        </div>
      </div>
    </>
  );
};

export default LoginView;
